import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="public-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/75 border-b border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center" aria-label="RestroSetup home">
          <img
            src="/logo.png"
            alt="RestroSetup — Solution for Restaurants"
            className="h-12 lg:h-14 w-auto"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-[#0A0A0A]" : "text-[#525252] hover:text-[#0A0A0A]"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/contact"
            data-testid="nav-cta-button"
            className="bg-[var(--brand-primary)] text-white hover:bg-[var(--brand-primary-hover)] px-5 py-2.5 text-sm font-medium rounded-sm transition-colors"
          >
            Get a Free Audit
          </Link>
        </div>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-white">
          <div className="flex flex-col px-6 py-4 gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="text-sm font-medium text-[#0A0A0A]"
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="bg-[var(--brand-primary)] text-white px-5 py-2.5 text-sm font-medium rounded-sm text-center"
              data-testid="mobile-nav-cta"
            >
              Get a Free Audit
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
